<template>
  <section>
    <form class="topup-form" @submit.prevent="submit">
      <div class="topup-form-frame">
        <h1 class="step-title" v-html="$t('component.autotopup.stage1.title')"></h1>
        <h2 class="dark-title" v-html="$t('component.autotopup.stage1.header')"></h2>

        <div class="topup-types-list">
          <div class="topup-types-list-content">
            <div class="topup-types-list-container">
              <input type="radio"
                     name="topupType"
                     id="topupTypePeriod"
                     :class="{ error: showError }"
                     @change="hideError"
                     v-model="form.condition"
                     :value="topupConditions.period"/>
              <label for="topupTypePeriod">
                {{ $t('component.autotopup.stage1.periodLabel') }}
              </label>
            </div>
            <div class="topup-types-list-container">
              <input type="radio"
                     name="topupType"
                     id="topupTypeDay"
                     :class="{ error: showError }"
                     @change="hideError"
                     v-model="form.condition"
                     :value="topupConditions.day"/>
              <label for="topupTypeDay">
                {{ $t('component.autotopup.stage1.dayLabel') }}
              </label>
            </div>
          </div>
          <div class="topup-types-list-errors" v-if="showError">
            <ul>
              <li>{{ $t('component.autotopup.stage1.errorTypeRequired') }}</li>
            </ul>
          </div>
        </div>

        <div v-if="isConditionSet" class="topup-form-fields fields-inline">
          <section class="topup-form-field-zone">
            <div class="topup-form-field-content">
              <div class="line">
                <div>{{ $t('component.autotopup.stage1.fieldAmountLabel1') }}</div>
                <div class="topup-form-field narrow-field">
                  <div class="topup-form-field-container" :class="{error: isTopupAmountError}">
                    <input type="text"
                           :aria-label="$t('component.autotopup.stage1.fieldAmountLabel1')"
                           id="form-amount-period"
                           maxlength="6"
                           v-model="form.amount"
                           @change="formatAmount"/>
                  </div>
                </div>
                <div>{{ $t('component.autotopup.stage1.fieldAmountLabel2') }}</div>
              </div>
            </div>
            <div class="topup-form-field-errors" v-if="formErrors && isTopupAmountError">
              <ul>
                <li>{{ $t('component.autotopup.stage1.errorAmountRequired') }}</li>
              </ul>
            </div>
          </section>
          <section class="topup-form-field-zone" v-if="isConditionPeriodSet">
            <div class="topup-form-field-content">
              <div class="line">
                <div>{{ $t('component.autotopup.stage1.fieldPeriodLabel1') }}</div>
                <div class="topup-form-field narrow-field">
                  <div class="topup-form-field-container" :class="{error: isTopupPeriodError}">
                    <input type="text"
                           :aria-label="$t('component.autotopup.stage1.fieldPeriodLabel1')"
                           maxlength="3"
                           id="form-period"
                           v-model="form.period"
                           @change="formatPeriod"/>
                  </div>
                </div>
                <div>{{ $t('component.autotopup.stage1.fieldPeriodLabel2') }}</div>
              </div>
              <div class="line">
                <div class="topup-form-field narrow-field">
                  <div class="topup-form-field-container" :class="{error: formErrors && isNextTopupDayError}">
                    <label aria-label="date" style="top: 0">
                      <el-date-picker
                        v-model="form.nextTopupDay"
                        :picker-options="pickerOptions"
                        type="date"
                        :placeholder="$t('component.autotopup.stage1.fieldPeriodPlaceholder')">
                      </el-date-picker>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="topup-form-field-errors" v-if="formErrors && (isTopupPeriodError || isNextTopupDayError)">
              <ul>
                <li v-if="isTopupPeriodError">{{ $t('component.autotopup.stage1.errorPeriodRequired') }}</li>
                <li v-if="isNextTopupDayError">{{ $t('component.autotopup.stage1.errorNextTopupDayRequired') }}</li>
              </ul>
            </div>
          </section>
          <section class="topup-form-field-zone" v-if="isConditionDaySet">
            <div class="topup-form-field-content">
              <div class="line">
                <div>{{ $t('component.autotopup.stage1.fieldTopupDayLabel1') }}</div>
                <div class="topup-form-field narrow-field">
                  <div class="topup-form-field-container">
                    <select v-model="form.topupDay" :aria-label="$t('component.autotopup.stage1.fieldTopupDayLabel1')">
                      <option :value="value" v-for="value in topupDaysList" :key="value">{{ value }}</option>
                    </select>
                  </div>
                </div>
                <div>{{ $t('component.autotopup.stage1.fieldTopupDayLabel2') }}</div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="topup-form-buttons">
        <span></span>
        <button type="submit" id="submit-autotopup-step-1"
                :title="$t('component.autotopup.stage1.a11y.toNextStepButton')">
          {{ $t('component.autotopup.stage1.buttonNext') }} ›
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import Stage1Mixin from '@/common/mixins/Topup/Auto/Stage1.mixin'

export default {
  name: 'TopupAutoStage1',
  mixins: [Stage1Mixin]
}
</script>

<style src="../../../assets/scss/topup-form.scss" lang="scss"></style>
